/* unplugin-vue-components disabled */import { render } from "./w-tag.vue?vue&type=template&id=27dfeda4&scoped=true&ts=true"
import script from "./w-tag.vue?vue&type=script&lang=ts"
export * from "./w-tag.vue?vue&type=script&lang=ts"

import "./w-tag.vue?vue&type=style&index=0&id=27dfeda4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dfeda4"]])

export default __exports__